import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// i18n must initialise before the app renders.
import './i18n';
// Theme first, then the phone-input base styles, then app-level overrides
// (app.scss must load last so its .dkn-phone rules win without !important).
import './styles/theme.scss';
import 'react-phone-number-input/style.css';
import './styles/app.scss';

import { AuthProvider } from './auth/AuthContext';
import { ColorModeProvider } from './theme/ColorMode';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
    <StrictMode>
        <ColorModeProvider>
            <AuthProvider>
                <App />
            </AuthProvider>
        </ColorModeProvider>
    </StrictMode>,
);
